import { NavListContext, useThrottledHandler } from 'App';
import { useSize } from 'ahooks';
import { Image, Toast } from 'antd-mobile';
import Img from 'app/img';
import { useContext, useEffect, useRef, useState } from 'react';
import { AiFillHome, AiOutlineCheckCircle, AiOutlineCrown, AiOutlineKey, AiOutlineSearch } from 'react-icons/ai';
import { useLocation, useNavigate } from 'react-router-dom';
import { TermsNodeListDT } from 'services/apis/cnt2/term-api';
import { isEmpty } from 'utils/listUtil';
import styles from './index.module.scss';

const TitleNav = (data: {}) => {
  const location = useLocation();
  const navigate = useNavigate();
  // const navList = useContext(NavListContext)?.navList;
  // const updateNavList = useContext(NavListContext).updateNavList;

  return (
    <>
      <div className=" flex items-center gap-3 p-0.5 bg-gradient-to-r from-orange-500/100 to-orange-400/100 text-white ">
        <div
          className={['relative grow flex items-center gap-2 pl-3', styles.container].join(' ')}
          onClick={() => {
            // console.log("navList", navList);
            // // 一级导航
            // const _top1TermNow = navList.top1TermList.find(
            //   (item) => item.termUuid === "CAT_1_1"
            // ) as TermsNodeListDT;
            // // 二级导航
            // const _top2TermList = isEmpty(_top1TermNow.termsNodeList)
            //   ? []
            //   : _top1TermNow.termsNodeList;
            // // 更新导航
            // updateNavList((draft) => {
            //   draft.btmTermNow = draft.btmTermList[0];
            //   draft.top2TermList = _top2TermList;
            //   draft.top1TermNow = _top1TermNow;
            //   draft.top2TermNow = _top2TermList[0];
            // });
            // navigate("/one");
            // Toast.show(location.pathname);
            navigate('/one/osusume');
            // if (location.pathname.endsWith('one/osusume')) {
            //   //
            // } else if (location.pathname.endsWith('one/mine')) {
            //   navigate('/one/osusume');
            // } else {
            //   window.history.go(-1);
            // }
          }}
        >
          <AiFillHome size={25} />
          {/* <Image src={Img.logo} height={28} /> */}
          <div className=" flex flex-col text-xs">
            <div className="">UU天堂, 梦想起航</div>
            <div className="-mt-0.5">UU天堂, 资源满仓</div>
          </div>
        </div>
        <div className=" flex gap-3 mt-1 mr-3 mb-1 whitespace-nowrap text-xs">
          <div
            className=" flex justify-center items-center gap-0.5 text-sm shadow-md rounded-md px-1.5 py-1 bg-gradient-to-r from-orange-500 to-pink-500 "
            onClick={useThrottledHandler(() => {
              Toast.show('即将进入口令模式');
              setTimeout(() => {
                navigate('/sesame');
              }, 1500);
            })}
          >
            <AiOutlineKey size={16} />
            <div>口令</div>
          </div>
          {/* <div
            className=" flex justify-center items-center gap-0.5 text-sm shadow-md rounded-md px-1.5 py-1 bg-orange-600"
            onClick={() => {
              navigate("/search", {
                state: {
                  searchAllCategory: true,
                  searchKeyword: null,
                  searchCategoryId: null,
                  searchCategory: "所有资源",
                },
              });
            }}
          >
            <AiOutlineSearch size={16} />
            <div>搜索</div>
          </div> */}
          {/* <div className=" flex flex-col items-center justify-center gap-0.5">
            <AiOutlineCrown size={16} />
            <div>VIP</div>
          </div> */}
          {/* <div className=" flex flex-col items-center justify-center gap-0.5">
            <AiOutlineCheckCircle size={16} />
            <div>签到</div>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default TitleNav;
